<template>
  <div>
    <ValueComparison
      :value="selectReportValue(widgetId)"
      :comparison="selectComparisonNumber(widgetId)"
      :hideNegativeComparison="true"
      comparisonVersusText="with Ovation"
      v-if="!loading"
    />
    <ValueComparisonLoader v-else />
  </div>
</template>

<script>
import ValueComparison from '@/components/Modules/Dashboard/Widget/ReportTypes/ValueComparison'
import ValueComparisonLoader from '@/components/Modules/Dashboard/Widget/SkeletonLoaders/ValueComparisonLoader'
import { createNamespacedHelpers } from 'vuex'

const DashboardModule = createNamespacedHelpers('dashboard')

export default {
  name: 'ReviewAverageOnlineRating',
  props: ['widgetId'],
  components: {
    ValueComparison,
    ValueComparisonLoader
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...DashboardModule.mapGetters(['selectComparisonNumber', 'selectReportValue'])
  },
  methods: {
    ...DashboardModule.mapActions(['fetchReviewAverageOnlineRating'])
  },
  async mounted() {
    await this.fetchReviewAverageOnlineRating({ widgetId: this.widgetId })
    this.loading = false
  }
}
</script>
